// js-build is generated with typescript - do not edit .js files in js-build directly.
import {ZIDXFileUploadProgress} from "../form/FileUploadProgress.js";
import jQuery from 'jquery';
import {ZIDXAccountInit} from "../account/account.js";
import {ZIDXModalWindow} from "../ModalWindow.js";
import {TableRowSorter} from "../form/TableRowSorter.js";
import {ZIDXBase} from "./base.js";
import {ZIDXMobileMenu} from "../MobileMenu.js";
import {PagesContainer} from "./PagesContainer.js";
import {IDXMap} from "./idxMap.js";

let $ = jQuery.noConflict();
declare var tinymce: any;

export class ZIDXOptionsContainer {
    hubspotEmbed: boolean = false;
    siteDomain: string = "";
    selectedSiteDomain: string = "";
    staticDomain: string = "";
    isDarkMode: boolean = false;
    prefix: string = "";
    freeTrial: boolean = false;
    enableRemoteSearch: boolean = false;
    zidxScrollTo: number = 0;
    enableListingPhotos: boolean = false;
    registerListingMode: number = 0;
    registerListingViewLimit: number = 0;
    registerAIPromptLimit: number = 0;
    siteId: number = 0;
    debug: boolean = false;
    aiEnabled: boolean = false;
    thisIsTestServer: boolean = false;
    thisIsDeveloper: boolean = false;
    recaptchaSiteKey: string = "";
    versionDate: string = "";
    // enableGoogleMaps: boolean = false;
    // googleMapsApiKey: string = "";
    wixApp: boolean = false;
    inAccount: boolean = false;
    inWixEditor: boolean = false;
    inAccountLogin: boolean = false;
    idxDisabled: boolean = false;
    enableCookies: boolean = true;
    proxyDomain="";
    selectedSiteId=0;
    listingThumbnailLayout: string = "1";
    listingDetailLayout: string = "1";
    aiChatMessageCount=0;
    aiChatMessageLimit=0;

    constructor() {
        // @ts-ignore
        let s = window.ZIDXOptions;
        this.hubspotEmbed = s.hubspotEmbed === true;
        this.prefix = s.prefix;
        this.freeTrial = s.freeTrial;
        this.isDarkMode = s.isDarkMode;
        this.enableRemoteSearch = s.enableRemoteSearch;
        this.zidxScrollTo = s.zidxScrollTo;
        this.enableListingPhotos = s.enableListingPhotos;
        this.registerListingViewLimit = s.registerListingViewLimit;
        this.registerAIPromptLimit = s.registerAIPromptLimit;
        this.registerListingMode = s.registerListingMode;
        this.selectedSiteDomain = s.selectedSiteDomain;
        this.siteDomain = s.siteDomain;
        this.staticDomain = s.staticDomain;
        this.siteId = s.siteId;
        this.debug = s.debug;
        this.aiEnabled = s.aiEnabled;
        this.thisIsTestServer = s.thisIsTestServer;
        this.thisIsDeveloper = s.thisIsDeveloper;
        this.recaptchaSiteKey = s.recaptchaSiteKey;
        this.versionDate = s.versionDate;
        // this.enableGoogleMaps = s.enableGoogleMaps;
        // this.googleMapsApiKey = s.googleMapsApiKey;
        this.wixApp = s.wixApp;
        this.inAccount = s.inAccount;
        this.inWixEditor = s.inWixEditor;
        this.inAccountLogin = s.inAccountLogin;
        this.enableCookies = s.enableCookies;
        this.idxDisabled = s.idxDisabled;
        this.proxyDomain=s.proxyDomain;
        this.selectedSiteId=s.selectedSiteId;
        this.listingThumbnailLayout = s.listingThumbnailLayout;
        this.listingDetailLayout = s.listingDetailLayout;
        this.aiChatMessageCount=s.aiChatMessageCount;
        this.aiChatMessageLimit=s.aiChatMessageLimit;
    }
}

export class ZIDXCookie {
    key: string = "";
    value: string = "";
    futureSeconds: number = -1;
    enableSubdomains: boolean = false;

    [index: string]: any;
};

export interface ZIDXPage {
    render: any;

    getPageClass(): string;
}

export class ZIDXPageSet {
    page: ZIDXPage | null = null;
    pageClass: string = "";
    $pageContainer: any = null;
    builtIn = false;
    alreadyLoaded = false;
}






class ExtractAjaxContentResponse {
    success: boolean = false;
    versionDate: string = "";
    errorMessage: string = "";
    forceReload: boolean = false;
    forceWindowLocationRedirect: boolean = false;
    redirectURL: string = "";
    title: string = "";
    data: string = "";
}










export class ZIDX{
    zidxMap=new IDXMap(this);
    pages:any={};
    options = new ZIDXOptionsContainer();
    recaptchaLoaded = false;
    tinyMCELoaded = false;
    wixAppPosition: any;
    wixAppScrollPosition: any;
    lastURL = "";
    runFunctionsIntervalID:string|number|NodeJS.Timeout = 0;
    firstRunLoadFunctions = true;
    lastLink=window.location.href;
    currentPageSet: ZIDXPageSet=new ZIDXPageSet();
    lastLoadedURL = "";
    disableWixPushState = false;
    testWixPushState = false;
    lastPageScrollTop = 0;
    ajaxCacheTableSort: any = {};
    ajaxSortURLCache: any = [];
    zCurrentEditButton = false;
    submitEventBoundCache:any = {};
    loadFunctions:Function[]=[];
    loadOnceFunctions:Function[]=[];
    windowHeight=0;
    iframeScrollY=0;

    lastScreenHeight: number = 0;
    currentDevice = -1;
    zIsTouchscreenCache = -1;

    ajaxData = {};
    ajaxLastRequestId = false;

    MSIEVersion = -1;
    MSIEBrowser = window.navigator.userAgent.indexOf("MSIE");
    scrollBarWidthCached = -1;
    scrollPosition = {left: 0, top: 0};
    windowSize={
        "width":0,
        "height":0
    };

    scrollbarWidth = 0;
    mousePosition = {x: 0, y: 0};
    modalWindow=new ZIDXModalWindow(this);
    peakidxShadowRoot: ShadowRoot | Document = document;
    zidxBase=new ZIDXBase(this);
    mobileMenu=new ZIDXMobileMenu(this);
    accountDomain="";
    constructor(peakidxShadowRoot:ShadowRoot|Document) {
        this.peakidxShadowRoot=peakidxShadowRoot;
        if(window.location.href.indexOf("/account/")!=-1){
            let accountInit=new ZIDXAccountInit(this);
        }
        this.pages=new PagesContainer(this).pages;
        if (this.MSIEBrowser != -1) {
            this.MSIEVersion = parseInt((window.navigator.userAgent.substring(this.MSIEBrowser + 5, window.navigator.userAgent.indexOf(".", this.MSIEBrowser))));
        }

        if (this.lastLoadedURL == "") {
            this.lastLoadedURL = window.location.href.replace(this.options.siteDomain, "").replace(this.options.prefix, "/");
        }

        if(this.options.siteDomain.indexOf(".win.zsite.info")!=-1){
            this.accountDomain="https://account.peak.win.zsite.info";
        }else if(this.options.siteDomain.indexOf(".test.zsite.info")!=-1){
            this.accountDomain="https://account.peak.test.zsite.info";
        }else{
            this.accountDomain="https://account.peakidxsites.com";
        }
        this.init();
    }
    numberFormat(amount:number):string{
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'decimal',
            minimumFractionDigits: 0,
        });
        return formatter.format(amount);
    }

    showLoginForm(){
        // Track login state before modal opens for sync detection
        this.zidxBase.zidx.modalWindow.setWasLoggedInBeforeModal(this.isContactLoggedIn());

        let disableClose = false;
        let width = 0;
        let height = 0;
        if ($(window).width()! < 992) {
            width = Math.min(600, $(window).width()! - 20);
            height = Math.min(500, $(window).height()! - 20);
        } else {
            width = Math.min(800, $(window).width()! - 50);
            height = Math.min(600, $(window).height()! - 50);
        }
        let url=new URL(window.location.href);
        let loginURL=this.options.siteDomain+"/login/?redirectURL="+encodeURIComponent(url.pathname + url.search)+"&forced=1&embedded=1&ztv="+Math.random();
        var modalContent1='<iframe id="zModalIframeLogin" src="'+loginURL+'" scrolling="yes" frameborder="0"  style=" margin:0px; border:none; overflow:auto; -webkit-overflow-scrolling: touch; position:relative; " seamless="seamless" width="100%" height="98%" />';
        this.zidxBase.zidx.modalWindow.showModal(modalContent1,{
            'width':width,
            'height':height,
            "maxWidth":width,
            "maxHeight":height,
            "padding":0,

            "disableClose":disableClose,
            "fullscreen":false});
    }
    getAbsoluteURL(url:string):string{
        if(url.startsWith("http://") || url.startsWith("https://")) {
            return url;
        }
        if(this.inIframe()) {
            return this.options.siteDomain+url;
        }else{
            if(this.options.proxyDomain!=""){
                return this.options.proxyDomain+url;
            }else{
                return this.options.siteDomain+url;
            }
        }
    }
    cookiesEnabled() {
        if (!this.options.enableCookies) {
            return false;
        }
        // if (this.iOS() && this.inIframe()) {
        //     return false;
        // }
        return true;
    }
    zIsTouchscreen() {
        if (this.zIsTouchscreenCache !== -1) {
            return this.zIsTouchscreenCache == 1;
        }
        var n = navigator.userAgent.toLowerCase();

        var patt = /(android|iphone|ipad|viewpad|tablet|bolt|xoom|touchpad|playbook|kindle|gt-p|gt-i|sch-i|sch-t|mz609|mz617|mid7015|tf101|g-v|ct1002|transformer|silk| tab)/g;
        if (n.replace(patt, "anything") !== n) {
            this.zIsTouchscreenCache = 1;
            return true;
        } else {
            this.zIsTouchscreenCache = 0;
            return false;
        }
    }
    inIframe() {
        try {
            return window.self !== window.top;
        } catch (e) {
            return true;
        }
    }
    iOS() {
        if (this.currentDevice >= 0) {
            return this.currentDevice == 1;
        }
        let devices = [
            'iPad',
            'iPhone',
            'iPod'
        ];
        // newer
        for (let i = 0; i < devices.length; i++) {
            if (navigator.platform.indexOf(devices[i]) != -1) {
                this.currentDevice = 1;
                return true;
            }
        }
        // ios 13
        if (navigator.userAgent.indexOf("Mac") != -1 && "ontouchend" in document) {
            this.currentDevice = 1;
            return true;
        }
        this.currentDevice = 0;
        return false;
    };
    getSelectValues(select: any) {
        var result = [];
        var options = select && select.options;
        var opt;
        var hasValue = false;

        for (var i = 0, iLen = options.length; i < iLen; i++) {
            if (options[i].value != "") {
                hasValue = true;
                break;
            }
        }
        for (var i = 0, iLen = options.length; i < iLen; i++) {
            opt = options[i];

            if (opt.selected) {
                // if (hasValue) {
                    result.push(opt.value);
                // } else {
                //     result.push(opt.text);
                // }
            }
        }
        return result;
    }

    getFormDataByFormId(formId: string) {
        var obj: any = {};
        let self=this;
        $("input, textarea, select", $("#" + formId, this.peakidxShadowRoot)).each(function (this: any) {
            if (typeof obj[this.name] === "undefined") {
                if (this.type === 'checkbox' || this.type === 'radio') {
                    if (this.checked) {
                        // console.log("radio checked", this.name, this.value);
                        obj[this.name] = this.value;
                    }
                } else if (this.type.substr(0, 6) === 'select') {
                    obj[this.name] = self.getSelectValues(this).join(",");
                } else {
                    obj[this.name] = this.value;
                }
            } else {
                if (this.type === 'checkbox' || this.type === 'radio') {
                    if (this.checked) {
                        obj[this.name] += "," + this.value;
                    }
                } else if (this.type.substr(0, 6) === 'select') {
                    obj[this.name] += "," + self.getSelectValues(this).join(",");
                } else {
                    obj[this.name] += "," + this.value;
                }
            }
        });
        return obj;
    }

    getAbsPosition(object: HTMLElement) {
        if (object == null || typeof object == "undefined" || typeof object.style == "undefined" || object.style.display == 'none') {
            return {x: 0, y: 0, width: 0, height: 0};
        }
        return object.getBoundingClientRect();
    }
    ajaxRequest  (obj: any) {
        // throw("test");
        var req: any = new XMLHttpRequest();
        req.idxRequestData = {
            requestCount: 0,
            requestEndCount: 0,
            cacheData: []
        };
        if (typeof obj.formId != "undefined" && typeof obj.postObj != "undefined") {
            alert("Only obj.formId should be used, obj.postObj is deprecated.");
            console.log("ajax request cancelled", obj, typeof obj.formId, typeof obj.postObj, "undefined", obj.postObj=="undefined");
            return;
        }
        var postData = "";
        if (typeof obj.formId == "undefined") {
            if (typeof obj.postObj === "undefined") {
                obj.postObj = {};
            }
            for (var i in obj.postObj) {
                postData += i + "=" + encodeURIComponent(obj.postObj[i]) + "&";
            }
        }
        if (typeof obj.cache === "undefined") {
            obj.cache = false;
        }
        if (typeof obj.method === "undefined") {
            obj.method = "get";
        }
        if (typeof obj.debug === "undefined") {
            obj.debug = false;
        }
        if (typeof obj.errorCallback === "undefined") {
            obj.errorCallback = function () {
                alert("There was a temporary server or network problem, please try again later.");
            };
        }
        if (typeof obj.ignoreOldRequests === "undefined") {
            obj.ignoreOldRequests = false;
        }
        if (typeof obj.url === "undefined" || typeof obj.callback === "undefined") {
            alert('this.zidx.ajaxRequest() Error: obj.url and obj.callback are required');
        }

        req.idxRequestData.requestCount++;
        req.idxRequestData.cache = obj.cache;
        req.idxRequestData.debug = obj.debug;
        req.idxRequestData.method = obj.method;
        req.idxRequestData.url = obj.url;
        req.idxRequestData.ignoreOldRequests = obj.ignoreOldRequests;
        req.idxRequestData.callback = obj.callback;
        req.idxRequestData.errorCallback = obj.errorCallback;
        if (req.idxRequestData.cache && req.idxRequestData.cacheData[obj.url] && req.idxRequestData.cacheData[obj.url].success) {
            req.idxRequestData.callback(req.idxRequestData.cacheData[obj.url].responseText);
        }
        let self=this;
        req.showRequestError = function (m: string) {
            if (self.isDeveloper() || self.isTestServer()) {
                // alert("Unexpected response.  See console for request and response objects.  Click ok to view response.");
                if (self.options.debug) console.log("Ajax Request Object");
                if (self.options.debug) console.log(req.idxRequestData);
                if (self.options.debug) console.log("Ajax Response Object");
                if (self.options.debug) console.log(req);
                // alert("ajax request had error, see console.");
                return false;
            } else {
                // if (m != "") {
                //     alert(m);
                // }
                return true;
            }
        }
        req.onerror = function (e: any) {
            // req.showRequestError("Sorry, but that server request failed to load right now, please refresh your browser or come back later.");
        }
        req.onreadystatechange = function () {
            if (req.readyState === 4 || req.readyState === "complete" || (self.MSIEBrowser !== -1 && self.MSIEVersion <= 7 && this.readyState === "loaded")) {
                var id = req.getResponseHeader("x-ajax-id");
                if (typeof id !== "undefined" && new String(id).indexOf(",") !== -1) {
                    id = id.split(",")[0];
                }
                if (req.status !== 200 && req.status !== 301 && req.status !== 302) {
                    if (req.idxRequestData.debug) {
                        req.showRequestError("");
                    } else {
                        var continueExecution = req.showRequestError("");
                        if (continueExecution) {
                        }
                    }
                    req.idxRequestData.errorCallback(req);
                }
                if (typeof req.idxRequestData !== "undefined") {
                    req.idxRequestData.requestEndCount++;
                    if (!req.idxRequestData.ignoreOldRequests || req.idxRequestData.requestCount === req.idxRequestData.requestEndCount) {
                        if (req.status === 200 || req.status === 301 || req.status === 302) {
                            if (req.idxRequestData.cache) {
                                req.idxRequestData.cacheData[req.idxRequestData.url] = new Object();
                                req.idxRequestData.cacheData[req.idxRequestData.url].responseText = req.responseText.trim();
                                req.idxRequestData.cacheData[req.idxRequestData.url].success = true;
                            }
                            req.idxRequestData.callback(req.responseText.trim());
                        }
                    }

                } else {
                    alert("Request failed due to browser incompatibility.");
                }
                self.ajaxLastRequestId = false;
            }
        };
        var randomNumber = Math.random() * 1000;
        var derrUrl = "";
        if (!this.isDeveloper() && !this.isTestServer()) {
            derrUrl = "&zFPE=1";
        }
        if (req.idxRequestData.debug) {
            derrUrl = "";
        }
        this.ajaxLastRequestId = obj.id;
        var action = req.idxRequestData.url;

        var isMacSafari = false;
        if (navigator.userAgent.indexOf("Safari") != -1 && (navigator.userAgent.indexOf("Mac OS") != -1)) {
            isMacSafari = true;
            var fileFieldCache: any = {};
        }
        if (typeof window.FormData != "undefined" && typeof obj.formId != "undefined") {
            var form = this.peakidxShadowRoot.getElementById(obj.formId);
            if (isMacSafari) {
                var offset1 = 0;
                $('input[type="file"]', $("#" + obj.formId, this.peakidxShadowRoot)).each(function (this: any) {
                    if (this.files.length == 0) {
                        fileFieldCache[offset1] = {parent: $(this).parent(), element: $(this).detach()};
                        offset1++;
                    }
                });
            }

            var formData = new FormData(<HTMLFormElement>form);
            var postObjTemp = this.getFormDataByFormId(obj.formId);
            for (var i in postObjTemp) {
                if (!formData.has(i) && postObjTemp[i] == "") {
                    formData.append(i, "");
                }
            }

            req.open(req.idxRequestData.method, action, true);
            req.withCredentials = true;
            req.setRequestHeader("x-ajax-id", obj.id);
            req.send(formData);
            setTimeout(function () {
                if (isMacSafari) {
                    for (var id in fileFieldCache) {
                        fileFieldCache[id].parent.append(fileFieldCache[id].element);
                    }
                }
            }, 500);

        } else {
            if (req.idxRequestData.method.toLowerCase() === "get") {
                req.open(req.idxRequestData.method, action, true);
                req.withCredentials = true;
                req.setRequestHeader("x-ajax-id", obj.id);
                //req.setRequestHeader("Accept-Encoding","gzip,deflate;q=0.5");
                //req.setRequestHeader("TE","gzip,deflate;q=0.5");
                req.send("");
            } else if (req.idxRequestData.method.toLowerCase() === "post") {
                //alert('not implemented - use zForm() instead');
                req.open(req.idxRequestData.method, action, true);
                req.withCredentials = true;
                req.setRequestHeader("x-ajax-id", obj.id);
                req.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

                if (typeof obj.formId != "undefined") {
                    var postObj: any = this.getFormDataByFormId(obj.formId);
                    var postData = "";
                    for (var i in postObj) {
                        postData += i + "=" + encodeURIComponent(postObj[i]) + "&";
                    }
                }
                req.send(postData);
            }
        }
    }
    isAIEnabled() {
        if (typeof this.options.aiEnabled !== "undefined" && this.options.aiEnabled) {
            return true;
        } else {
            return false;
        }
    }
    isTestServer() {
        if (typeof this.options.thisIsTestServer !== "undefined" && this.options.thisIsTestServer) {
            return true;
        } else {
            return false;
        }
    }
    isDeveloper() {
        if (typeof this.options.thisIsDeveloper !== "undefined" && this.options.thisIsDeveloper) {
            return true;
        } else {
            return false;
        }
    }

    getMousePosition(e:JQuery.MouseMoveEvent) {
        var sl = document.documentElement.scrollLeft;
        var st = document.documentElement.scrollTop;
        if (typeof sl === "undefined") sl = document.body.scrollLeft;
        if (typeof st === "undefined") st = document.body.scrollTop;
        var xMousePosMax = window.innerWidth + window.pageXOffset;
        var yMousePosMax = window.innerHeight + window.pageYOffset;
        var xMousePos = 0;
        var yMousePos = 0;
        if (e.pageX) {
            xMousePos = e.pageX;
        } else if (e.clientX) {
            xMousePos = e.clientX + (sl);
        }
        if (e.pageY) {
            yMousePos = e.pageY;
        } else if (e.clientY) {
            yMousePos = e.clientY + (st);
        }
        return {x: xMousePos, y: yMousePos, pageWidth: xMousePosMax, pageHeight: yMousePosMax};
    }

    mouseHitTest(object: HTMLElement, marginInPixels: number) {
        if (object == null || typeof object == "undefined" || typeof object.style == "undefined" || object.style.display == 'none') {
            return false;
        }


        var p = this.getAbsPosition(object);
        if (typeof marginInPixels == "undefined") {
            marginInPixels = 0;
        }
        if (p.width == 0 && p.height == 0) {
            return false;
        }
        if (p.x - marginInPixels <= this.mousePosition.x) {
            if (p.x + p.width + marginInPixels >= this.mousePosition.x) {
                if (p.y + window.scrollY - marginInPixels <= this.mousePosition.y) {
                    if (p.y + window.scrollY + p.height + marginInPixels >= this.mousePosition.y) {
                        return true;
                    }
                }
            }
        }
        return false;
    }
    getScrollBarWidth() {
        if (this.scrollBarWidthCached !== -1) {
            return this.scrollBarWidthCached;
        }
        var inner = document.createElement('p');
        inner.style.width = "100%";
        inner.style.height = "200px";

        var outer = document.createElement('div');
        outer.style.position = "absolute";
        outer.style.top = "0px";
        outer.style.left = "0px";
        outer.style.visibility = "hidden";
        outer.style.width = "200px";
        outer.style.height = "150px";
        outer.style.overflow = "hidden";
        outer.appendChild(inner);

        var b = document.documentElement || document.body;
        b.appendChild(outer);
        var w1 = inner.offsetWidth;
        outer.style.overflow = 'scroll';
        var w2 = inner.offsetWidth;
        if (w1 === w2) w2 = outer.clientWidth;

        b.removeChild(outer);
        this.scrollBarWidthCached = (w1 - w2);
        return this.scrollBarWidthCached;
    };
    findPosition(obj: HTMLElement) {
        var curleft, curtop, curwidth, curheight;
        curleft = curtop = curwidth = curheight = 0;
        if (obj.offsetParent) {
            curleft = obj.offsetLeft;
            curtop = obj.offsetTop;
            curwidth = obj.offsetWidth;
            curheight = obj.offsetHeight;
            while (true) {
                obj = <HTMLElement>obj.offsetParent;
                if (typeof obj === "undefined" || obj === null) {
                    break;
                } else {
                    curleft += obj.offsetLeft;
                    curtop += obj.offsetTop;
                }
            }
        }
        return [curleft, curtop, curwidth, curheight];
    }
    jumpToId(id: string, offset: number) {
        var r94 = this.peakidxShadowRoot.getElementById(id);
        if (r94 === null) return;
        var p = this.findPosition(r94);
        if (!offset || offset === null) {
            offset = 0;
        }
        console.log("jumpToId scrollTo");
        window.scrollTo(0, p[1] + offset);
    }
    getClientWindowSize() {
        var myWidth = 0, myHeight = 0;
        if (typeof (window.innerWidth) === 'number') {
            //Non-IE
            myWidth = window.innerWidth;
            myHeight = window.innerHeight;
        } else if (document.documentElement && (document.documentElement.clientWidth || document.documentElement.clientHeight)) {
            //IE 6+ in 'standards compliant mode'
            myWidth = document.documentElement.clientWidth;
            myHeight = document.documentElement.clientHeight;
        } else if (document.body && (document.body.clientWidth || document.body.clientHeight)) {
            //IE 4 compatible
            myWidth = document.body.clientWidth;
            myHeight = document.body.clientHeight;
        }
        if (this.scrollbarWidth === 0) {
            this.scrollbarWidth = this.getScrollBarWidth();
        }
        this.windowSize = {
            "width": myWidth,//-this.scrollbarWidth,
            "height": myHeight
        };
        return this.windowSize;
    }
    getAbsolutePositionRect(element:Element) {

        const rect = element.getBoundingClientRect();
        let newRect={
            top: rect.top,
            left: rect.left,
            right: rect.right,
            bottom: rect.bottom,
            width: rect.width,
            height: rect.height,
            x: rect.x,
            y: rect.y,
        };
        // let componentContainer=this.peakidxShadowRoot.querySelector("#zidxComponentContainer");
        let scrollY=window.scrollY;
        let scrollX=window.scrollX;
        // if(componentContainer){
        //     let containerRect=componentContainer.getBoundingClientRect();
        //     console.log(rect, containerRect);
        //     scrollY=Math.max(0, scrollY - containerRect.top);
        //     scrollX=Math.max(0, scrollX - containerRect.left);
        //     // newRect.top=containerRect.top-newRect.top+ scrollY;
        //     // newRect.left=containerRect.left-newRect.left+ scrollX;
        //     // newRect.right=containerRect.left-newRect.right+ scrollY;
        //     // newRect.bottom=containerRect.top-newRect.bottom+ scrollX;
        //     // newRect.x=newRect.left;
        //     // newRect.y=newRect.top;
        //     // the map should be positioned at the top of the container which is component - rect + adjusted scrollY
        //     console.log(containerRect.top, rect.top, newRect.top, scrollY, window.scrollY);
        // }
        newRect.top+=scrollY;
        newRect.left+=scrollX;
        newRect.right+=scrollX;
        newRect.bottom+=scrollY;
        newRect.x+=scrollX;
        newRect.y+=scrollY;
        return newRect;
    }
    scrollThrottleId: number | null = null;
    zSetScrollPosition() {
        if (this.scrollThrottleId) return;

        this.scrollThrottleId = requestAnimationFrame(() => {
            this.scrollThrottleId = null;
            this.doSetScrollPosition();
        });
    }
    doSetScrollPosition() {
        this.getClientWindowSize();
        var ScrollTop = document.body.scrollTop;
        if (ScrollTop === 0) {
            if (window.pageYOffset) {
                ScrollTop = window.pageYOffset;
            } else {
                ScrollTop = (document.body.parentElement) ? document.body.parentElement.scrollTop : 0;
            }
        }
        this.scrollPosition.top = ScrollTop;
        var ScrollLeft = document.body.scrollLeft;
        if (ScrollLeft === 0) {
            if (window.pageXOffset) {
                ScrollLeft = window.pageXOffset;
            } else {
                ScrollLeft = (document.body.parentElement) ? document.body.parentElement.scrollLeft : 0;
            }
        }
        this.scrollPosition.left = ScrollLeft;
        // if (typeof window.ZWIXAppScroll != "undefined") {
        //     this.scrollPosition.top = Math.max(0, window.ZWIXAppScroll.scrollTop - window.ZWIXAppScroll.y);
        //     if (this.options.debug) console.log("wix scrollTop", this.scrollPosition.top, window.ZWIXAppScroll);
        // }
        this.displayLoadMore();
        if ($(".zidxPageActive .zidxSearchContainer", this.peakidxShadowRoot).length!=0) {
            $(".zidxPageActive", this.peakidxShadowRoot).attr("data-scroll-top", Math.round(this.scrollPosition.top));
            this.setMapPosition(true);
        }
    }
    mapPositionIntervalId:any=null;
    setMapPosition(allowInterval:boolean){
        let mapIframeElement=this.peakidxShadowRoot.querySelector("#zidxMapIframe")! as HTMLIFrameElement;
        if(mapIframeElement === null){
            return;
        }
        let mapRect=this.getAbsolutePositionRect(mapIframeElement);
        let containerRect=this.getAbsolutePositionRect(this.peakidxShadowRoot.querySelector(".zidxSearchResultsContainer")!);
        let self=this;
        mapIframeElement.style.position="fixed";
        if(!this.zidxBase.isAndroid() && allowInterval) {
            clearInterval(this.mapPositionIntervalId);
            this.mapPositionIntervalId = setInterval(function () {
                if (mapIframeElement.style.position == "relative") {
                    mapIframeElement.style.position = "fixed";
                    self.setMapPosition(false); // correct the position a final time
                    clearInterval(self.mapPositionIntervalId);
                }
            }, 50);
        }
        let searchContainer = $(".zidxSearchContainer", this.peakidxShadowRoot)[0];
        let searchContainerPosition = searchContainer.getBoundingClientRect();
        let mapContainer = $(".zidxSearchMapContainer", this.peakidxShadowRoot)[0];
        let mapContainerPosition = mapContainer.getBoundingClientRect();
        // console.log("setMapPosition1", containerRect.top, window.scrollY, containerRect.bottom, mapRect.height, searchContainerPosition.height, searchContainerPosition.y);
        // console.log("setMapPosition", window.scrollY, mapContainerPosition, containerRect, mapRect);
        if(mapIframeElement) {
            let bottomLimit=containerRect.bottom-mapRect.height;
            let top=0;
            // console.log("ahh", bottomLimit, window.scrollY, searchContainerPosition.height+searchContainerPosition.y);
            let scrollY=window.scrollY;
            if(self.iframeScrollY!=0){
                // iframe mode
                scrollY=-(self.iframeScrollY-containerRect.top);
                if(self.iframeScrollY<containerRect.top) {
                    scrollY=0;
                }
                if (bottomLimit + scrollY < 0) {
                    top = bottomLimit;
                } else {
                    top = Math.max(containerRect.top - scrollY, 0);
                }
            }else {
                // console.log("bottomLimit", bottomLimit, "map Height", mapRect.height, mapRect.top, "bot", containerRect.bottom, "scrollY", scrollY);
                if (bottomLimit - scrollY < 0) {// && searchContainerPosition.height+searchContainerPosition.y<=0){//mapContainerPosition.height+10){
                    top = bottomLimit - scrollY;//+searchContainerPosition.height+10;
                    // console.log("map position from bottom");
                } else {
                    top = Math.max(containerRect.top - scrollY, 0);
                    // console.log("map position from top");
                }
            }
            // console.log("set map top", top, scrollY, containerRect.top, "bottomLimit", bottomLimit, "containerRect", containerRect.top);
            // let top=Math.max(Math.max(containerRect.top-window.scrollY, 0), containerRect.bottom-mapRect.height);
            mapIframeElement.style.left = Math.round(mapContainerPosition.x + 10) + "px";
            mapIframeElement.style.top=(top)+"px";
            mapIframeElement.style.zIndex="2";
        }

    }
    getAbsolutePosition(element:HTMLElement) {
        const rect = element.getBoundingClientRect();
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return {
            top: rect.top + scrollTop,
            left: rect.left + scrollLeft
        };
    }
    loadLazyImages() {
        let scrollTop = this.scrollPosition.top + this.windowSize.height;
        let self=this;
        $(".zidxLazyLoadBackgroundImage", this.peakidxShadowRoot).each(function (this: HTMLElement) {
            let position = this.getBoundingClientRect();
            if (scrollTop > position.top) {
                $(this).attr("style", self.getListingBackgroundImageCSS(this.getAttribute("data-image")!, false)).removeClass("zidxLazyLoadBackgroundImage");
            }
            // if(this.options.debug) console.log(this.scrollPosition.top, "image top", position.top);
        });
    }

    getListingBackgroundImageCSS(photoLink: string, useThumbnail: boolean): string {
        // let webpLink = photoLink.replace(".jpg", ".webp");
        // if (useThumbnail) {
        //     webpLink = webpLink.replace(".webp", "-thumbnail.webp");
        // }
        return "background-image:url(\"" + photoLink + "\"); ";// background-image: -webkit-image-set(    url(\"" + webpLink + "\") 1x); background-image: image-set(    \"" + webpLink + "\" 1x); ";
    };
    getCookie(key: string) {
        if (!this.cookiesEnabled()) {
            return "";
        }
        let arrCookie = document.cookie.split(";");
        for (let i = 0; i < arrCookie.length; i++) {
            let cookie = arrCookie[i].split("=");
            if (cookie.length < 2) {
                continue;
            }
            let cookieName = cookie[0].trim();
            if (cookieName == key) {
                return decodeURIComponent(cookie[1].trim());
            }
        }
        return "";
    }

    deleteCookie (key: string) {
        this.setCookie({key: key, value: "", futureSeconds: -1, enableSubdomains: false, deleting: true});
    }
    setCookie (obj: ZIDXCookie) {
        if (!this.cookiesEnabled()) {
            return;
        }
        if (typeof obj !== "object") {
            throw("zSetCookie requires an obj like {key:'cookie'',value:'value',futureSeconds:60,enableSubdomains:false}.");
        }
        if (typeof obj.deleting == "undefined") {
            this.deleteCookie(obj.key);
        }
        var dObj: any = {futureSeconds: 0, enableSubdomains: false};
        for (var i in obj) {
            dObj[i] = obj[i];
        }
        var newC = dObj.key + "=" + encodeURIComponent(dObj.value);
        if (dObj.futureSeconds !== 0) {
            var currtime = new Date();
            currtime = new Date(currtime.getTime() + dObj.futureSeconds * 1000);
            newC += "; expires=" + currtime.toUTCString();
        }
        if (dObj.enableSubdomains) {
            newC += "; domain=" + window.location.hostname.replace("www.", "").replace("secure.", "");
        }
        newC += "; path=" + "/";//this.options.prefix; // do not url encode this!
        if (window.location.href.indexOf("https://") != -1) {
            newC += ";secure;samesite=none";
            if (this.options.hubspotEmbed) newC += ";partitioned";
        }
        // if (this.options.debug) console.log("set cookie:", newC);
        document.cookie = newC;
    }


    closeOtherMenus() {
        $(".zidxManagerQuickMenu").removeClass("zidxActive");
        if (typeof this.zCurrentEditButton == "object") {
            $(".zidxManagerEditMenu").removeClass("zidxActive");
            $(".zidxManagerRowActive").removeClass("zidxManagerRowActive");
            if (typeof this.zCurrentEditButton != "boolean" && this.mouseHitTest(this.zCurrentEditButton, 0)) {

                $(".zidxManagerEditMenu", $(this.zCurrentEditButton).parent()).addClass("zidxActive");
                $(this.zCurrentEditButton).parent().parent().parent().addClass("zidxManagerRowActive");
            } else {
                this.zCurrentEditButton = false;
            }
        }
    }

    zManagerBindTableEvents() {
        let self=this;
        let doc=this.peakidxShadowRoot;
        // has to always be run because the gear links sometimes don't exist yet.
        $(doc).on("click", ".zidxManagerQuickMenuLinks a", function (e: JQuery.ClickEvent) {
            e.stopPropagation();
            return true;
        });
        $(doc).on("click", ".zidxManagerQuickMenu", function (e: JQuery.ClickEvent) {
            e.preventDefault();
            self.closeOtherMenus();
            setTimeout(function () {
                $(".zidxManagerQuickMenu").addClass("zidxActive");
            }, 30);
        });

        $(doc).on("click", ".zidxManagerEdit", function (this: any, e: JQuery.ClickEvent) {
            self.closeOtherMenus();
            if ($(".zidxManagerEditMenu", $(this).parent()).length == 0) {
                return true;
            }
            let self2=this;
            e.preventDefault();
            setTimeout(function () {
                self.zCurrentEditButton = self2;
            }, 30);
            $(".zidxManagerEditMenu", $(this).parent()).addClass("zidxActive");
            $(this).parent().parent().parent().addClass("zidxManagerRowActive");
        });
        $(doc).on("click", function (e: JQuery.ClickEvent) {
            self.closeOtherMenus();
        });
        doc.addEventListener('click', (e: Event) => {
            const target = e.target as HTMLAnchorElement;
            const row = target.closest('.zidxDeleteTableRecordRow');

            if (row) {
                const rowLink = row as HTMLAnchorElement;
                e.preventDefault();
                self.deleteTableRecordRow(rowLink, rowLink.href);
            }
        });
    }

    calculateTableCells(table: HTMLTableElement) {
        let max = 0;
        for (let i = 0; i < table.rows.length; i++) {
            if (max < table.rows[i].cells.length) {
                max = table.rows[i].cells.length;
            }
        }
        return max;
    }

    deleteTableRecordRow(obj: any, deleteLink: string) {
        let tr: any, table: any;
        let self=this;
        let i = 0;
        while (true) {
            i++;
            if (obj.tagName.toLowerCase() == 'tr') {
                tr = obj;
            } else if (obj.tagName.toLowerCase() == 'table') {
                table = obj;
                break;
            }
            if (obj.parentNode != null) {
                obj = obj.parentNode;
            }
            if (i > 50) {
                alert('infinite loop. invalid table html structure');
                return false;
            }
        }
        var cellCount = this.calculateTableCells(table);

        $("td", tr).css("border-top", "2px solid #900");
        $("td", tr).css("border-bottom", "2px solid #900");
        $("td", tr).css("background-color", "#FFF0F0");
        var r = confirm("Are you sure you want to delete this record?");
        $("td", tr).css("border-top", "0px solid #CCC");
        $("td", tr).css("border-bottom", "1px solid #CCC");
        $("td", tr).css("background-color", "inherit");
        if (r) {
            let ajax = {
                id: "ajaxDeleteTableRecord",
                method: "get",
                ignoreOldRequests: true,
                callback: function (r: string) {
                    let js = JSON.parse(r);
                    if (js.success) {
                        $(tr).html('<td class="zidxDeletedRow" colspan="' + cellCount + '">Row Deleted</td>');
                        self.setupAjaxTableSortAgain();
                    } else {
                        alert('Failed to delete the record. Error:\n\n' + js.errorMessage);
                    }

                },
                errorCallback: function (r: string) {
                    alert('Failed to delete the record. Unknown error');
                },
                url: deleteLink
            };
            this.ajaxRequest(ajax);
        }
        return false;

    }

    setupAjaxTableSortAgain() {
        // for (var tableId in this.zidxAjaxCacheTableSort) {
        //     var c = this.zidxAjaxCacheTableSort[tableId];
        //     this.setupAjaxTableSort(c.tableId, c.ajaxURL, c.ajaxVarName, c.ajaxVarNameOriginal, c.ajaxCallback);
        // }
    }
    setupRecordSort(table:Element, callback:Function) {
        let ajaxURL=table.getAttribute("data-ztable-sort-ajax-url")!;
        let disableAjax=table.getAttribute("data-ztable-disable-ajax")=="true";
        let sortVarNameAjax=table.getAttribute("data-ztable-sort-ajax-name")!;
        let ajaxVarNameOriginal=table.getAttribute("data-ztable-sort-ajax-original")!;
        this.setupAjaxTableSort(table.id, disableAjax, ajaxURL, sortVarNameAjax, ajaxVarNameOriginal, callback);
    }
    setupAjaxTableSort(tableId: string, disableAjax:boolean, ajaxURL: string, ajaxVarName: string, ajaxVarNameOriginal: string, ajaxCallback: Function) {

        let self=this;
        this.ajaxCacheTableSort[tableId] = {
            tableId: tableId,
            ajaxURL: ajaxURL,
            ajaxVarName: ajaxVarName,
            ajaxVarNameOriginal: ajaxVarNameOriginal,
            ajaxCallback: ajaxCallback
        };

        var validated = true;
        var arrError = [];
        if (tableId == "" || $('#' + tableId, this.peakidxShadowRoot).length == 0) {
            validated = false;
            arrError.push('queueSortCom.ajaxTableId is set to "' + tableId + '", but this table is missing.');
            return;
        }
        if ($('#' + tableId + ' thead', this.peakidxShadowRoot).length == 0) {
            validated = false;
            arrError.push('queueSortCom.ajaxTableId is set to "' + tableId + '", but this table is missing the <thead> tag around the header rows, which is required for table row sorting to function.');
        }
        if ($('#' + tableId + ' tbody', this.peakidxShadowRoot).length == 0) {
            validated = false;
            arrError.push('queueSortCom.ajaxTableId is set to "' + tableId + '", but this table is missing the <tbody> tag around the body rows, which is required for table row sorting to function.');
        }
        this.ajaxSortURLCache[tableId] = {
            url: ajaxURL
        };
        var arrSort: any[] = [];
        $('#' + tableId + ' tbody tr', this.peakidxShadowRoot).each(function (this) {
            if (this.id == '') {
                validated = false;
            } else {
                if ($("." + tableId + "_handle", this).length) {
                    var v = $("." + tableId + "_handle", this)[0].getAttribute('data-ztable-sort-primary-key-id');
                    if (v != "") {
                        arrSort.push(v);
                    }
                }
            }
        });
        var originalSortOrderList = arrSort.join("|");
        $("#" + tableId + " tbody", this.peakidxShadowRoot).attr("data-original-sort", originalSortOrderList);
        if (validated) {
            // alert("sortable not implemented because jquery ui is not able to be in module");
            const table = this.peakidxShadowRoot.getElementById(tableId) as HTMLElement;
            const sorter = new TableRowSorter(table, tableId + '_handle', (sortOrder: string[]) => {
                var originalSortOrderList = $("#" + tableId + " tbody", this.peakidxShadowRoot).attr("data-original-sort");
                var sortOrderList = sortOrder.join("|");
                // console.log("sorted list:"+sortOrderList);
                var tempObj: any = {};
                tempObj.id = "zidxAjaxChangeSortOrder";
                tempObj.url = this.ajaxSortURLCache[tableId].url;
                tempObj.method = "post";
                tempObj.postObj = {};
                tempObj.postObj[ajaxVarName] = sortOrderList;
                tempObj.postObj[ajaxVarNameOriginal] = originalSortOrderList;
                if(disableAjax){
                    ajaxCallback(tempObj);
                    return;
                }
                tempObj.callback = function (r: string) {
                    var d = JSON.parse(r);
                    if (!d.success) {
                        alert(d.errorMessage);
                    } else {
                        self.ajaxSortURLCache[tableId].cache = $("#" + tableId, this.peakidxShadowRoot).html();

                        let arrSort: any[] = [];
                        $('#' + tableId + ' tbody tr', this.peakidxShadowRoot).each(function (this) {
                            if (this.id == '') {
                                validated = false;
                            } else {
                                if ($("." + tableId + "_handle", this).length) {
                                    var v = $("." + tableId + "_handle", this)[0].getAttribute('data-ztable-sort-primary-key-id');
                                    if (v != "") {
                                        arrSort.push(v);
                                    }
                                }
                            }
                        });
                        originalSortOrderList = arrSort.join("|");
                        $("#" + tableId + " tbody", this.peakidxShadowRoot).attr("data-original-sort", originalSortOrderList);
                        ajaxCallback(tempObj);
                    }
                };
                tempObj.errorCallback = function () {
                    alert("Failed to sort records.");
                };
                tempObj.cache = false;
                tempObj.ignoreOldRequests = false;
                self.ajaxRequest(tempObj);
            });
        } else {
            arrError.push('Each <tr> row must have a unique id attribute and a data-ztable-sort-primary-key-id attribute with the value set to the primary key id for the current record.');
        }
        if (arrError.length) {
            alert(arrError.join("\n"));
        }
    }

    extractAjaxContent(r: string, builtIn: boolean): ExtractAjaxContentResponse {
        var title = "";
        var body = "";
        var h = r;
        var start = '<!-- zidx-spa-version:';
        var end = ': -->';
        var startPosition = h.indexOf(start);
        var endPosition = h.indexOf(end, startPosition + start.length);
        var versionDate = "";
        var forceReload = false;
        try {
            versionDate = h.substr(startPosition + start.length, endPosition - (startPosition + start.length));
        } catch (e) {
            // couldn't parse body, might not have one
            if (this.options.debug) console.log("Failed to parse body for versionDate");
        }
        if (versionDate.length != 0 && versionDate != this.options.versionDate) {
            if (this.options.debug) console.log("extractAjaxContent: Version changed, forceReload:", versionDate, "!=", this.options.versionDate);
            forceReload = true;
            body = h;
        } else {
            if (builtIn) {
                start = '<!-- zidx-spa-builtin-content-start -->';
                end = '<!-- zidx-spa-builtin-content-end -->';
                // if (this.options.debug) console.log("Looking for builtin comment");
            } else {
                start = '<!-- zidxSPABodyContent-start -->';
                end = '<!-- zidxSPABodyContent-end -->';
                // if (this.options.debug) console.log("Looking for spabodycontent comment");
            }
            startPosition = h.indexOf(start);
            endPosition = h.indexOf(end, startPosition + start.length);
            try {
                body = h.substr(startPosition + start.length, endPosition - (startPosition + start.length));
            } catch (e) {
                // couldn't parse body, might not have one
            }
            if (body.length == 0) {
                body = 'Sorry, an invalid response has been returned.<br><br>' + r;
            }
        }
        start = '<title>';
        end = '</title>';
        startPosition = h.indexOf(start);
        endPosition = h.indexOf(end, startPosition + start.length);
        try {
            title = h.substr(startPosition + start.length, endPosition - (startPosition + start.length));
        } catch (e) {
            // couldn't parse title, might not have one.
        }
        if (title == "") {
            start = 'data-spa-title="';
            end = '"';
            startPosition = h.indexOf(start);
            endPosition = h.indexOf(end, startPosition + start.length);
            if (this.options.debug) console.log("try second title");
            try {
                title = h.substr(startPosition + start.length, endPosition - (startPosition + start.length));
                if (this.options.debug) console.log("title was ", title);
            } catch (e) {
                // couldn't parse body, might not have one
            }
        }
        return {
            success: true,
            versionDate: versionDate,
            errorMessage: "",
            forceReload: forceReload,
            redirectURL: "",
            forceWindowLocationRedirect: false,
            title: title,
            data: body
        };
    }
    getPage(originalURL: string, url: string, skipPushState: boolean, showAlert: boolean): ZIDXPageSet {
        let self=this;
        url=this.getRootRelativeURL(url);
        let pageSet = new ZIDXPageSet();
        // $(".zidxBodyElement", this.peakidxShadowRoot).removeClass("zidxDisableBodyScroll");
        let position = url.indexOf("?");
        let qs = "";
        if (position != -1) {
            qs = url.substring(position + 1);
            url = url.substring(0, position);
            if (url.length == 0) {
                url = "/";
            }
        }
        // if (this.options.debug) console.log("getPage url:", url, "qs:", qs);
        this.lastScreenHeight = 0;
        if (url == "/") {
            pageSet.page = this.pages["/"]()!;
            if(this.options.idxDisabled) {
                pageSet.pageClass = "zidxSiteHomeDisableIdxContainer";
            }else{
                pageSet.pageClass = "zidxSiteHomeContainer";
            }
        } else {
            $(".zidxFooterDisclaimerContainer", this.peakidxShadowRoot).css("width", "100%");
            // console.log("this.pages", this.pages);
            let arrParts = url.split("?");
            arrParts = arrParts[0].split("#");
            // console.log("getPage", arrParts);
            if (this.pages[arrParts[0]]) {
                pageSet.page = this.pages[arrParts[0]]();
                pageSet.pageClass = pageSet.page!.getPageClass();
            }
            if (pageSet.page == null) {
                for (let matchURL in this.pages) {
                    if (matchURL != "/" && url.substring(0, matchURL.length) == matchURL) {
                        pageSet.page = this.pages[matchURL]();
                        pageSet.pageClass = pageSet.page!.getPageClass();
                        break;
                    }
                }
            }
        }
        // console.log("url", url, "pages", this.pages);
        // console.log("options", this.options, "pageSet", pageSet, "url:", url, "originalURL:", originalURL, "skipPushState:", skipPushState);
        if (pageSet.page != null) {
            pageSet.builtIn = true;
            pageSet.$pageContainer = $("." + pageSet.pageClass, this.peakidxShadowRoot);
            var newContainer = false;
            if (pageSet.$pageContainer.length == 0) {
                newContainer = true;
                let page = document.createElement("div");
                page.className = "zidxPageContainer " + pageSet.pageClass + " zidxPageActive";
                page.setAttribute("data-last-url", url.split("#")[0]);
                page.setAttribute("data-last-title", "");
                let container = this.peakidxShadowRoot.getElementById("zidxBodyContainer");
                if (container == null) {
                    throw("Template is missing element with id: zidxBodyContainer");
                }
                container.appendChild(page);
                container.insertBefore(page, container.firstElementChild);
                pageSet.$pageContainer = $(page);
            }
            if (pageSet.$pageContainer.length == 0) {
                throw("$pageContainer missing: ." + pageSet.pageClass);
            }
            // console.log(pageSet, newContainer, pageSet.$pageContainer.attr("data-last-url"));
            let lastURL = pageSet.$pageContainer.attr("data-last-url");
            if (typeof lastURL == "undefined") {
                lastURL = "";
            }
            lastURL = this.getRootRelativeURL(lastURL);
            let currentURL = this.getRootRelativeURL(originalURL);
            // console.log("compare original:\n", currentURL, " == lastURL without prefix:\n", lastURL);
            if (!newContainer && currentURL == lastURL) {
                if (!pageSet.$pageContainer.hasClass("zidxPageActive")) {
                    // if (this.options.debug) console.log("already loaded, redisplayed", originalURL);
                    $(".zidxPageContainer", this.peakidxShadowRoot).removeClass("zidxPageActive");
                    pageSet.$pageContainer.addClass("zidxPageActive");
                    let title = pageSet.$pageContainer.attr("data-last-title");
                    document.title = title;
                    if (!skipPushState) {
                        // pushState must be run later in order to allow wix back button to work
                        setTimeout(function () {
                            // if (self.options.debug) console.log("history.pushState:", originalURL);
                            console.log("pushState already loaded:", originalURL);
                            if (self.inIframe() && self.zidxBase.iframeChildManager) {
                                self.zidxBase.iframeChildManager.navigate(originalURL, title);
                            } else {
                                window.history.pushState({}, title, originalURL);
                            }
                        }, 10);
                    }
                }
                // compare query string to alreadyLoaded url
                let arrPartOld = currentURL.split("?");
                let arrPartNew = lastURL.split("?");
                // console.log("alreadyLoadedCheck: compare old:", arrPartOld, " new: ", arrPartNew);
                if (arrPartOld.length > 1) {
                    if (arrPartNew.length > 1) {
                        if (arrPartOld[1] == arrPartNew[1]) {
                            pageSet.alreadyLoaded = true; // page was already loaded, we don't need to reload
                        }
                    }
                } else {
                    pageSet.alreadyLoaded = true; // page was already loaded, we don't need to reload
                }
            }
            this.displayLoadMore();
            // console.log("alreadyLoaded:"+pageSet.alreadyLoaded);
        } else if (showAlert) {
            alert("missing page with url: " + url);
            console.log("missing page with url: " + url);
        }
        // if (this.options.debug) console.log("matched pageSet", pageSet);

        this.displayLoadMore();
        return pageSet;
    }

    initPage(alreadyLoaded: boolean) {
        let self=this;
        // if (this.options.debug) console.log("ZIDX cookie versionDate:", this.options.versionDate);
        // if (this.options.wixApp) {
        //     window.Wix.getAdsOnPage(function (e: any) {
        //         for (let i = 0; i < e.length; i++) {
        //             let ad = e[i];
        //             if (ad.top == 0) {
        //                 window.ZWIXBannerOffset = ad.height;
        //             }
        //         }
        //     });
        // }
        let recaptchaEnabled = false;
        $("form", $(".zidxPageContainer.zidxPageActive", this.peakidxShadowRoot)).each(function (this) {
            let recaptchaEnabledTemp = this.getAttribute("data-recaptcha-enabled");
            if (recaptchaEnabledTemp && recaptchaEnabledTemp == "1") {
                recaptchaEnabled = true;
                if (self.options.debug) console.log("recaptchaEnabled:", recaptchaEnabled);
            }
        });


        if (recaptchaEnabled) {
            this.loadRecaptcha();
            $(".grecaptcha-badge", this.peakidxShadowRoot).show();
        } else {
            $(".grecaptcha-badge", this.peakidxShadowRoot).hide();
        }

        $(".zidxSelectAllCheckboxes", this.peakidxShadowRoot).on("click", function (this: HTMLElement, e: JQuery.ClickEvent) {
            let field=$(this).attr("data-field");
            let checkboxes=$("input[name='"+field+"']", self.peakidxShadowRoot);
            for(let i=0;i<checkboxes.length;i++) {
                let checkbox=checkboxes[i] as HTMLInputElement;
                checkbox.checked=(this as HTMLInputElement).checked;
            }
        });

        $(".zidxAccordionHeader", this.peakidxShadowRoot).on("click", function (this: HTMLElement, e: JQuery.ClickEvent) {
            e.preventDefault();
            let id = $(this).attr("data-accordion-item");
            if ($("#" + id, self.peakidxShadowRoot).hasClass("zidxAccordionOpen")) {
                $("#" + id, self.peakidxShadowRoot).removeClass("zidxAccordionOpen");
                $("#" + id, self.peakidxShadowRoot).addClass("zidxAccordionClosed");
            } else {
                $("#" + id, self.peakidxShadowRoot).removeClass("zidxAccordionClosed");
                $("#" + id, self.peakidxShadowRoot).addClass("zidxAccordionOpen");
            }
            if((this as HTMLAnchorElement).href!=window.location.href.split("#")[0]+"#") {
                self.loadPushStateURL((this as HTMLAnchorElement).href, false);
                return false;
            }else{
                if(self.peakidxShadowRoot instanceof ShadowRoot) {
                    window.scrollTo(0, self.getAbsPosition($("#" + id, self.peakidxShadowRoot)[0]).y+window.scrollY-150);
                }else{
                    window.scrollTo(0, self.getAbsPosition($("#" + id, self.peakidxShadowRoot)[0]).y);
                }
            }
            $(window).trigger("resize");
        });
        this.loadLazyImages();
        // if (this.options.debug) console.log("initPage");
        this.initTinyMCEEditors();
        this.initAccordions();
    }
    renderResponse(r: string, pageSet: ZIDXPageSet, originalURL: string, skipPushState: boolean, obj: any, currentPageSet: ZIDXPageSet, url: string, pageScrollTop: number, parentInitiated: boolean = false) {
        var rs = new ExtractAjaxContentResponse();
        let self = this;

        console.log("[ZIDX] renderResponse called:", { originalURL, skipPushState, parentInitiated });

        if (r.toLowerCase().indexOf('<html') != -1) {
            rs = this.extractAjaxContent(r, pageSet.builtIn);
        } else {
            try {
                rs = JSON.parse(r);
                if (rs.success) {
                    if (rs.versionDate.length != 0 && rs.versionDate != this.options.versionDate) {
                        if (this.options.debug) console.log("Version changed, forceReload:", rs.versionDate, "!=", this.options.versionDate);
                        rs.forceReload = true;
                    } else if (typeof rs.data != "undefined") {
                        let start = '<!-- zidx-spa-builtin-content-start -->';
                        let end = '<!-- zidx-spa-builtin-content-end -->';
                        let startPosition = rs.data.indexOf(start);
                        let endPosition = rs.data.indexOf(end, startPosition + start.length);
                        try {
                            rs.data = rs.data.substr(startPosition + start.length, endPosition - (startPosition + start.length));
                        } catch (e) {}
                        if (rs.data.length == 0) {
                            rs.data = 'Sorry, an invalid response has been returned.<br><br>' + r;
                        }
                    } else {
                        rs.success = true;
                        rs.title = "Sorry, there was a temporary problem";
                        rs.data = '<h1>Sorry, there was a temporary problem</h1><p>Please refresh the page.</p>';
                    }
                }
            } catch (e) {
                rs.success = true;
                rs.title = "Sorry, there was a temporary problem";
                rs.data = '<h1>Sorry, there was a temporary problem</h1><p>Please refresh the page.</p>';
                if (this.options.debug) console.log(e, r);
            }
        }

        var title = "";
        if (rs.success) {
            document.title = rs.title;
            title = rs.title;

            if (typeof rs.forceReload != "undefined" && rs.forceReload) {
                if (this.options.debug) console.log("forceReload to " + obj.url);
                console.log("forceReload", obj.url);
                window.location.href = obj.url;
                return;
            } else if (typeof rs.redirectURL != "undefined" && rs.redirectURL != "") {
                if (typeof rs.forceWindowLocationRedirect != "undefined" && rs.forceWindowLocationRedirect) {
                    if (currentPageSet != null) {
                        currentPageSet.$pageContainer.remove();
                    }
                    console.log("redirecting to " + rs.redirectURL);
                    window.location.replace(rs.redirectURL);
                } else {
                    this.loadPushStateURL(rs.redirectURL, false);
                }
                return;
            } else {
                if (pageSet.page != null) {
                    pageSet.$pageContainer.attr("data-last-url", url);
                    pageSet.$pageContainer.attr("data-last-title", title);
                    $(".zidxPageContainer", this.peakidxShadowRoot).removeClass("zidxPageActive");
                    pageSet.$pageContainer.addClass("zidxPageActive");
                    pageSet.$pageContainer.html(rs.data);
                    this.initPage(false);
                    pageSet.page.render();
                } else {
                    throw("navigate with zidxSPABodyContent - must add ZIDXPage class for url: " + url);
                }
            }
        } else {
            $(".zidxSPABodyContent", this.peakidxShadowRoot).html(rs.errorMessage);
        }

        // Handle navigation state
        if (this.inIframe() && this.zidxBase.iframeChildManager) {
            if (parentInitiated) {
                // Parent navigated us - just update our URL state with replaceState
                console.log("[ZIDX] Parent-initiated render, calling handleParentNavigation");
                this.zidxBase.iframeChildManager.handleParentNavigation(originalURL, title);
            } else if (!skipPushState) {
                // User-initiated - tell parent to update history with pushState
                console.log("[ZIDX] User-initiated render, calling navigate");
                this.zidxBase.iframeChildManager.navigate(originalURL, title);
            }
        } else if (!skipPushState) {
            // Not in iframe - use normal pushState
            setTimeout(function () {
                console.log("pushState (loaded):", originalURL);
                window.history.pushState({}, title, originalURL);
            }, 10);
        }

        if($(".zidxEmbeddedBody", this.peakidxShadowRoot).length > 0) {
            if($(".zidxPageActive.zidxSiteHomeContainer", this.peakidxShadowRoot).length == 0 &&
                $(".zidxPageActive.zidxResultsContainer", this.peakidxShadowRoot).length == 0) {
                window.scrollTo(0, pageScrollTop);
            } else {
                window.scrollTo(0, pageScrollTop);
            }
        } else {
            this.scrollToTop();
        }
    }
    displayLoadMore(){
        if($(".zidxListingScrollContainer", this.peakidxShadowRoot).length==0){
            $(".zidxLoadMoreContainer", this.peakidxShadowRoot).hide();
            return;
        }
        if ($(".zidxPageActive .zidxListingScrollContainer", this.peakidxShadowRoot).length == 0) {
            $(".zidxLoadMoreContainer", this.peakidxShadowRoot).hide();
        }else{
            // if (this.windowSize.width < 767) {
            //     $(".zidxLoadMoreContainer", this.peakidxShadowRoot).hide();
            // } else {
            // }
            $(".zidxLoadMoreContainer", this.peakidxShadowRoot).show();
        }
    }
    getRootRelativeURL(url:string):string{
        if(url.startsWith(this.options.proxyDomain)) {
            // console.log("proxy mode before ajaxSPA get", originalURL, "prefix", this.options.prefix);
            if (url.startsWith(this.options.proxyDomain)) {
                url = url.replace(this.options.proxyDomain, "");
            }
        }
        if(url.startsWith(this.options.prefix)){
            url=url.replace(this.options.prefix, "/");
        }
        if(url.startsWith(this.options.siteDomain)){
            url=url.replace(this.options.siteDomain, "");
        }
        return url;
    }
    // loadSPA spaLoad is loadPushStateURL
    loadPushStateURL(url: string, skipPushState: boolean, parentInitiated: boolean = false) {
        console.log("[ZIDX] loadPushStateURL called:", { url, skipPushState, parentInitiated });

        this.hideMobileMenu();

        if(url.indexOf("/account/")!=-1){
            window.location.href = url;
            return;
        }
        url = url.split("#")[0];
        let originalURL = url;
        // the server returns root-relative paths (for example the AI search result URL). When the site runs under a
        // prefix (wordpress proxy, cdn), the browser URL must keep that prefix or a reload would miss the proxy route.
        if (!this.inIframe() && this.options.prefix && this.options.prefix != "/" && originalURL.startsWith("/") && !originalURL.startsWith(this.options.prefix)) {
            originalURL = this.getPrefixURL(originalURL);
        }
        url = this.getRootRelativeURL(url);

        console.log("[ZIDX] After getRootRelativeURL:", url);

        if (url.substr(0, 7) == "http://" || url.substr(0, 8) == "https://") {
            if (this.options.debug) console.log("url didn't match, no loadPushState:", originalURL, url);
            console.log("[ZIDX] Full URL detected, redirecting:", url);
            window.location.href = url;
            return;
        }

        // For parent-initiated navigation, we should NOT skip if URL is same
        // because we need to re-render the page state
        if (!parentInitiated && this.lastLoadedURL == url) {
            if(this.options.debug) console.log("skipped pushstate, lastLoadedURL was same:" + url);
            return;
        }
        this.lastLoadedURL = url;

        if(url!='/' && url!='/results/') {
            $(".zidxLoadMoreContainer", this.peakidxShadowRoot).hide();
        } else {
            if (this.zidxBase.infiniteScroll && this.zidxBase.infiniteScroll.loadedCount > this.zidxBase.infiniteScroll.panelCount) {
                $(".zidxLoadMoreContainer", this.peakidxShadowRoot).show();
            } else {
                $(".zidxLoadMoreContainer", this.peakidxShadowRoot).hide();
            }
        }

        this.zidxBase.hideMap();
        let pageSet = this.getPage(originalURL, url, skipPushState, false);
        let pageScrollTop = parseInt($(".zidxPageActive", this.peakidxShadowRoot).attr("data-scroll-top")!);
        if (typeof pageScrollTop == "undefined" || isNaN(pageScrollTop)) {
            pageScrollTop = 0;
        }
        this.lastPageScrollTop = pageScrollTop;
        this.currentPageSet = pageSet;

        this.displayLoadMore();

        console.log("[ZIDX] pageSet.alreadyLoaded:", pageSet.alreadyLoaded, "pageSet.page:", pageSet.page != null);

        if (pageSet.alreadyLoaded) {
            this.initPage(true);
            if(this.options.debug) console.log("page already loaded | skipPushState:" + skipPushState + " | parentInitiated:" + parentInitiated);
            $(window).trigger("clientresize");

            // Handle navigation state for iframe mode
            if (this.inIframe() && this.zidxBase.iframeChildManager) {
                let title = pageSet.$pageContainer.attr("data-last-title") || document.title;
                if (parentInitiated) {
                    // Parent navigated us (back/forward) - just update our URL state
                    // DO NOT send IframeLocationChange - this would cause parent to pushState
                    // and wipe out forward history
                    console.log("[ZIDX] Parent-initiated (cached), calling handleParentNavigation");
                    this.zidxBase.iframeChildManager.handleParentNavigation(originalURL, title);
                } else if (!skipPushState) {
                    // User-initiated navigation - tell parent to update history
                    console.log("[ZIDX] User-initiated (cached), calling navigate");
                    this.zidxBase.iframeChildManager.navigate(originalURL, title);
                }
                // If skipPushState=true but NOT parentInitiated, don't send anything
                // This handles edge cases like initial page load
            } else if (!skipPushState && !parentInitiated) {
                // Not in iframe - use normal pushState (only for user-initiated)
                let title = pageSet.$pageContainer.attr("data-last-title") || document.title;
                console.log("pushState (already loaded):", originalURL);
                window.history.pushState({}, title, originalURL);
            }

            if($(".zidxPageActive.zidxSiteHomeContainer", this.peakidxShadowRoot).length==0 &&
                $(".zidxPageActive.zidxResultsContainer", this.peakidxShadowRoot).length==0){
                // Not on search page
            } else {
                this.zidxMap.mode="markers";
                if(this.zidxMap.mapIframe && this.zidxMap.mapIframe.contentWindow) {
                    let restoreMarkersMessage = { type: "restoreMarkers" };
                    this.zidxMap.mapIframe.contentWindow.postMessage(restoreMarkersMessage, this.accountDomain);
                }
                setTimeout(function () {
                    window.scrollTo(0, pageScrollTop);
                }, 10);
            }
            if (pageSet.$pageContainer.html() == "") {
                alert("1. page container class may be wrong: " + pageSet.pageClass);
            }
            return;
        }

        let ajaxURL = this.getRootRelativeURL(originalURL);
        let self = this;
        let link = ajaxURL;
        if(!link.startsWith("http://") && !link.startsWith("https://")) {
            link = this.options.siteDomain + link;
        }
        console.log("[ZIDX] Loading with ajax:", link);

        let obj = {
            id: "ajaxSPA",
            method: "get",
            ignoreOldRequests: false,
            callback: function(t: any) {
                self.renderResponse(t, pageSet, originalURL, skipPushState, obj, self.currentPageSet, url, pageScrollTop, parentInitiated);
            },
            errorCallback: function (e: XMLHttpRequest) {
                if (e.status == 0) {
                    $(".zidxSPABodyContent", self.peakidxShadowRoot).html('<div class="zidxContainer zidx-pv-40"><h1>Sorry, the request could not be completed.</h1><p>Your Internet connection may have failed or the server is having a temporary problem. Please try again later.</p></div>.');
                } else {
                    self.renderResponse(e.responseText, pageSet, originalURL, skipPushState, obj, self.currentPageSet, url, pageScrollTop, parentInitiated);
                }
            },
            url: link
        };
        self.ajaxRequest(obj);
    }
    scrollToTop() {
        if(window.scrollY == 0) {
            return;
        }
        window.scrollTo(0, 0);

        // In iframe mode, also tell parent to scroll to top
        if (this.inIframe() && this.zidxBase.iframeChildManager) {
            this.zidxBase.iframeChildManager.scrollToTop();
        }
    }

    hideMobileMenu() {
        if ($(".zidxMobileMenu", this.peakidxShadowRoot).length > 0) {
            $(".zidxMobileMenu", this.peakidxShadowRoot).removeClass("zidxOpen");
            $(".zidxMobileHeaderOverlay", this.peakidxShadowRoot).removeClass("zidxOpen");
            $(".zidxMobileMenuIcon", this.peakidxShadowRoot).removeClass("zidxOpen");
            $(".zManagerEditMenu", this.peakidxShadowRoot).removeClass("zidxActive");
            // $("body").removeClass("zidxMobileMenuDisableScroll");
        }
    }

    hideMenuOnResize() {
        if (this.windowSize.width >= 992 && $(".zidxMobileMenu", this.peakidxShadowRoot).hasClass("zidxOpen")) {
            this.hideMobileMenu();
        }
    }

    getDomain(link: string) {
        if (link.substr(0, 8) == "https://" || link.substr(0, 7) == "http://") {
            var p = link.indexOf("/", 9);
            link = link.substr(0, p - 1);
        } else {
            link = window.location.href;
            var p = link.indexOf("/", 9);
            link = link.substr(0, p - 1);
        }
        var arrLink = link.split("#");
        return arrLink[0];
    }
    init(){
        let self=this;

        $.fn.extend({
            filterByText: function (this: any, textbox: any) {
                return this.each(function (this: any) {
                    var select: any = this;
                    var options: any = [];
                    <any>($(select, self.peakidxShadowRoot).find('option')).each(function () {
                        options.push({
                            value: $(this).val(),
                            text: $(this).text()
                        });
                    });
                    $(select, self.peakidxShadowRoot).data('options', options);

                    $(textbox, self.peakidxShadowRoot).on('change keyup', function () {
                        var options = $(select, self.peakidxShadowRoot).empty().data('options');
                        var search = $.trim(<string>$(textbox, self.peakidxShadowRoot).val());
                        var regex = new RegExp(search, "gi");

                        $.each(options, function (i) {
                            var option = options[i];
                            if (option.text.match(regex) !== null) {
                                $(select, self.peakidxShadowRoot).append(
                                    $('<option>', self.peakidxShadowRoot).text(option.text).val(option.value)
                                );
                            }
                        });
                    });
                });
            }
        })

        $.event.special.touchstart = {
            setup: function (_, ns: any, handle: any) {
                if (typeof ns.includes != "undefined") {
                    this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
                }
            }
        };
        $.event.special.touchmove = {
            setup: function (_, ns: any, handle: any) {
                if (typeof ns.includes != "undefined") {
                    this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
                }
            }
        };
        $.event.special.wheel = {
            setup: function (_, ns: any, handle: any) {
                this.addEventListener("wheel", handle, {passive: true});
            }
        };
        $.event.special.mousewheel = {
            setup: function (_, ns: any, handle: any) {
                this.addEventListener("mousewheel", handle, {passive: true});
            }
        };

        $(document).on("scroll", function (e: JQuery.ScrollEvent) {
            self.zSetScrollPosition();
            self.loadLazyImages();
        });
        $(document).on("mousemove", function (e) {
            self.mousePosition = self.getMousePosition(e);
        });

        $(window).on("clientresize resize", function (ev: any) {
            self.getClientWindowSize();

            self.hideMenuOnResize();
            // if (self.options.wixApp && window.ZIDXWixLibraryLoaded) {
            //     self.setWixHeight();
            // }

        });
        this.getClientWindowSize();
        this.zManagerBindTableEvents();
        $(".zidxManagerListTabButton").on("click", function (e: JQuery.ClickEvent) {
            e.preventDefault();
            self = e.target;
            var link = $(self).attr("data-click-location");
            if (link && window.location.href.indexOf("searchOn=") != -1) {
                window.location.href = link;
                return;
            }
            $(".zidxManagerListTabButton").each(function (this: any) {
                $(this).removeClass("zidxActive");
                $(this).toggleClass("zidxMobileActive");
                if (self == this) {
                    return;
                }
                var tab = $(this).attr("data-tab");
                if (tab != "") {
                    $("." + tab).removeClass("zidxActive");
                    $("." + tab).removeClass("zidxMobileActive");
                }
            });
            var tab = $(self).attr("data-tab");
            if (tab != "") {
                $(".zManagerTabContainer").show();
                $("." + tab).addClass("zidxActive");
                $("." + tab).toggleClass("zidxMobileActive");
            }
            $(self).addClass("zidxActive");
            $(self).toggleClass("zidxMobileActive");
        });

        $(window).on("popstate", function (e: any) {
            let state = (<PopStateEvent>e.originalEvent).state;
            console.log("popstate in child", state);
            var arrLink = window.location.href.split("#");
            if(arrLink.length > 1 && arrLink[1].indexOf("zModal") != -1) {
                return;
            }
            var link = arrLink[0];
            if(link == self.lastLink && $(".zModalOverlayDiv").length > 0) {
                self.modalWindow.closeModal();
                return;
            }
            self.lastLink = link;
            if (state != null && typeof state.disableSPABack != "undefined" && state.disableSPABack) {
                link = link.replace("ajaxLoad=", "ztv=");
            }

            // In iframe mode, parent handles back/forward via NavigateToPage message
            // So we only need to handle popstate for non-iframe mode
            if (!self.inIframe()) {
                console.log("[ZIDX] popstate (non-iframe) loading url:", link);
                self.loadPushStateURL(link, true);
            } else {
                console.log("[ZIDX] popstate (iframe mode) - waiting for parent NavigateToPage message");
            }
            // In iframe mode, the parent will send NavigateToPage message
            // which is handled by iframeChildManager.onNavigateCallback
        });
        setInterval(function () {
            if (typeof self.options.inAccount != "undefined" && self.options.inAccount) {
                if (!self.isLoggedIn() && window.location.href.indexOf('/login') == -1) {
                    window.location.href = "/login?zlogout=1&loginRedirectURL=" + encodeURIComponent(window.location.href);
                }
            }
        }, 1000);


        setInterval(function() {
            for(let formId in self.submitEventBoundCache){
                if(self.peakidxShadowRoot.querySelector("#"+formId)==null){
                    delete self.submitEventBoundCache[formId];
                }
            }
            self.loadCloudFileFields();
            let htmlForms=self.peakidxShadowRoot.querySelectorAll(".zidxForm");
            for(let i=0;i<htmlForms.length;i++){
                let htmlForm=htmlForms[i];
                if(htmlForm==null || typeof self.submitEventBoundCache[htmlForm.id]!="undefined" || htmlForm.getAttribute("data-event-bound")!=null){
                    continue;
                }
                self.submitEventBoundCache[htmlForm.id]=true;
                htmlForm.setAttribute("data-event-bound", "1");
                (htmlForm as HTMLFormElement).addEventListener("submit", function (this:HTMLElement, e: Event) {
                    if ($(this).attr("method") == "get") return true;
                    e.preventDefault();
                    let formId = $(this).attr("id")!;
                    let self2 = this;
                    let recaptchaEnabled = $(this).attr("data-recaptcha-enabled");
                    // console.log("recaptchaEnabled", recaptchaEnabled, recaptchaEnabled == "1");
                    $("#zidxformStatusMessage" + formId, self.peakidxShadowRoot).html('');

                    let fileUploadingField = <HTMLInputElement>self.peakidxShadowRoot.getElementById("fileUploadingField" + formId);
                    if (fileUploadingField) {
                        let uploading = parseInt(fileUploadingField.value);
                        if (uploading > 0) {
                            setTimeout(function () {
                                $(self2).trigger("submit");
                            }, 500);
                            return false;
                        }
                    }

                    if (typeof recaptchaEnabled != "undefined" && recaptchaEnabled == "1") {
                        // console.log("recaptcha enabled for form:", formId);
                        window.grecaptcha.ready(function () {
                            window.grecaptcha.execute(self.options.recaptchaSiteKey, {action: 'submit'}).then(function (token: string) {
                                $("#recaptchaToken" + formId, self.peakidxShadowRoot).val(token);
                                // console.log("set recaptcha token for form:", formId, token);
                                self.submitFormData(formId);
                            });
                        });
                    } else {
                        // console.log("recaptcha not enabled for form:", formId);
                        self.submitFormData(formId);
                    }
                    return false;
                });
            }
        }, 100);

        setInterval(function(){
            let links=self.peakidxShadowRoot.querySelectorAll("a");
            for(let i=0;i<links.length;i++){
                let link=links[i];
                let bound=link.getAttribute("data-click-bound");
                if(bound==null){
                    link.setAttribute("data-click-bound","1");
                    if ($(link).hasClass("zidxDisableSPALink") || $(link).hasClass("zidxManagerEdit")) {
                        continue;
                    }
                    link.addEventListener("click", function (this: any, e:Event) {
                        if (this.target == "_blank") {
                            // console.log("nav: return true on new window");
                            e.preventDefault();
                            window.open(this.href);
                            return false;
                        }
                        let arrLink = this.href.split("#");
                        let link = arrLink[0].replace(self.options.siteDomain, "");
                        // console.log("nav link click", link);
                        if(arrLink.length>1) {
                            e.preventDefault();
                            // console.log("nav: return false on hash");
                            return false;
                        }
                        // if (this.href.substr(this.href.length - 1, 1) == "#") {
                        //     e.preventDefault();
                        //     console.log("nav: return false on hash");
                        //     return false;
                        // }
                        if (typeof self.options.prefix != "undefined" && self.options.prefix != "") {
                            // check if url contains prefix
                            let currentPageDomain = self.getDomain(window.location.href);
                            if (link.indexOf(currentPageDomain) != -1 && (link.substr(0, 8) == "https://" || link.substr(0, 7) == "http://")) {
                                link = link.replace("https://", "").replace("http://", "");
                                let p = link.indexOf("/");
                                link = link.substr(p);
                            }
                            // need the root relative url
                            if (link.substr(0, self.options.prefix.length) != self.options.prefix) {
                                if (!$(this).hasClass("zidxEnableSPA")) {
                                    // console.log("nav: enable spa return true");
                                    return true;
                                }
                            }
                        }
                        if ($(".zidxSPABodyContent", self.peakidxShadowRoot).length > 0) {
                            // console.log("nav: loadpushstate");
                            self.loadPushStateURL(link, false);
                            e.preventDefault();
                            return false;
                        }
                        // console.log("nav: regular click");
                        window.location.href = link;
                    });
                }
            }
        }, 100);

    }
    redirectFormResponse (r: any, redirectOnSaveURL: string, ) {
        document.title = r.title;
        if (typeof r.redirectURL != "undefined") {
            if (r.redirectURL.startsWith('http')) {
                window.location.href = r.redirectURL;
                return;
            }

            if (redirectOnSaveURL != "") {
                r.redirectURL = redirectOnSaveURL;
            }
            if (typeof r.forceWindowLocationRedirect != "undefined" && r.forceWindowLocationRedirect) {
                // remove the page html for security
                if (this.currentPageSet != null) {
                    this.currentPageSet.$pageContainer.remove();
                }
                if(isNaN(this.lastPageScrollTop)){
                    this.lastPageScrollTop=0;
                }
                window.location.replace(this.zidxBase.urlAppend(r.redirectURL.replaceAll("zidxScrollTo=", "disableZIDXScrollTo="), "zidxScrollTo=" + this.lastPageScrollTop));
            } else {
                this.loadPushStateURL(r.redirectURL, false);
            }
        } else {
            if (this.options.debug) console.log(r);
            alert("Invalid response - see console");
        }
    }
    submitFormData(formId: string) {
        let formElement: any = this.peakidxShadowRoot.getElementById(formId);
        let redirectOnSaveURL = "";
        let redirectField = $("#redirectOnSaveURL" + formId, this.peakidxShadowRoot);
        if (redirectField.length > 0) {
            redirectOnSaveURL = redirectField.val()! as string;
        }
        let self=this;
        let obj = {
            id: "ajaxIDXFormSubmission",
            method: "post",
            formId: formId,
            // postObj:postObj,
            ignoreOldRequests: false,
            callback: function (r1: string) {
                let r = JSON.parse(r1);
                if (r.success) {
                    self.redirectFormResponse(r, redirectOnSaveURL)
                } else {
                    let captchaImage=$("#zidxCaptchaImage"+formId, self.peakidxShadowRoot);
                    if(captchaImage.length>0){
                        captchaImage.attr("src", self.options.siteDomain+"/captcha/?t="+new Date().getTime());
                        let captchaInput=$("#zidxCaptchaInput"+formId, self.peakidxShadowRoot);
                        captchaInput.val("");
                    }
                    self.scrollToTop();
                    $("#zidxformStatusMessage" + formId, self.peakidxShadowRoot).html('<div class="zidxErrorStatusMessage"><p style="margin-top:0px;font-weight:bold;">Please correct these items and try again.</p><p>' + r.errorMessage.replace(/\n/g, "<br>") + '</p></div>');
                }
                // if(skipPushState==false){
                // 	window.history.pushState({}, title, obj.url);
                // }
                // console.log("scrollToTop3");
                // scrollToTop();
                // hideMobileMenu();
            },
            errorCallback: function (e: any) {
                self.scrollToTop();
                $("#zidxformStatusMessage" + formId, self.peakidxShadowRoot).html('<div class="zidxErrorStatusMessage"><h1>Sorry, the request could not be completed.</h1><p>Please try again later</p></div>');
            },
            url: formElement.action
        };
        self.ajaxRequest(obj);
    }
    isContactLoggedIn() {
        if (this.getCookie("ZIDXCONTACTLOGGEDIN") == "") {
            return false;
        }
        return true;
    }
    isContactGuest() {
        if (this.getCookie("ZIDXCONTACTGUEST") == "") {
            return false;
        }
        return true;
    }
    isLoggedIn() {
        if (this.getCookie("ZIDXLOGGEDIN") == "") {
            return false;
        }
        return true;
    }
    getPrefixURL(link: string): string {
        if(this.inIframe()) {
            return link;
        }else{
            link = link.replace(this.options.siteDomain, "");
            if (link.substring(0, 5) == "http:" || link.substring(0, 6) == "https:") {
                return link;
            } else {
                return this.options.prefix + link.substring(1);
            }
        }
    }
    runLoadFunctions() {
        let self=this;
        // if (this.options.wixApp && !window.ZIDXWixLibraryLoaded) {
        //     setTimeout(function () {
        //         self.runLoadFunctions();
        //     }, 30);
        //     return;
        // }
        let originalURL = window.location.href;
        let url = originalURL.replace(this.options.siteDomain, "").replace(this.options.prefix, "/");
        url = url.split("#")[0];
        if (this.lastURL == url) {
            return; // don't repeat more than one per page
        }
        this.lastURL = url;
        if (this.firstRunLoadFunctions) {
            this.firstRunLoadFunctions = false;
            let arrURL = url.split("?");

            // note: YOU CAN NEVER REMOVE THE wix query string.  On iOS is breaks the wix iframe api.
            // if (this.options.debug) console.log("runLoadFunctions url: " + url);
            let isSuccessPage = this.peakidxShadowRoot.getElementById("zidxResponseError") == null;
            let pageSet = this.getPage(originalURL, url, true, isSuccessPage);
            if (pageSet.page != null) {
                pageSet.$pageContainer.attr("data-last-url", url.split("#")[0]);
                window.scrollTo(0, this.options.zidxScrollTo);
                if (isSuccessPage && pageSet.$pageContainer.html() == "") {
                    alert("2. page container class may be wrong: " + pageSet.pageClass);
                }
                this.currentPageSet = pageSet;
                this.initPage(false);
                if (pageSet.page != null) {
                    pageSet.page.render();
                }
            }
            // if (this.options.wixApp) {
            //     if (arrURL[0] != "/") {
            //         this.setWixHeight();
            //     }
            // }
        }
        if (this.loadOnceFunctions.length > 0) {
            var a = this.loadOnceFunctions;
            this.loadOnceFunctions = [];
            // if(this.options.debug) console.log('runLoad count:'+a.length);
            for (var i = 0; i < a.length; i++) {
                a[i]();
            }
        }
        if (this.loadFunctions.length > 0) {
            var a = this.loadFunctions;
            // if(this.options.debug) console.log('runLoad count:'+a.length);
            for (var i = 0; i < a.length; i++) {
                a[i]();
            }
        }

        if (this.runFunctionsIntervalID == 0) {
            this.runFunctionsIntervalID = setInterval(function () {
                self.runLoadFunctions();
            }, 30);
        }
    }

    setupFileChangeEvent(formId: string, obj: HTMLElement, isImage: boolean) {
        let self = this;
        // console.log("bind file", $(".zidxCloudFileUploadField", this.peakidxShadowRoot).length);
        $(".zidxCloudFileUploadField", this.peakidxShadowRoot).on("change", function (this: HTMLInputElement) {
            let progressElement = (<HTMLProgressElement>self.peakidxShadowRoot.getElementById(obj.id + "_progress")!);
            console.log("file change", self.peakidxShadowRoot.getElementById(obj.id + "_usertable"), obj.id + "_usertable");
            $(progressElement).show();
            let previewElement = (<HTMLDivElement>self.peakidxShadowRoot.getElementById(obj.id + "_preview")!);
            let fieldElement = (<HTMLInputElement>self.peakidxShadowRoot.getElementById(obj.id + "")!);
            let urlElement = (<HTMLInputElement>self.peakidxShadowRoot.getElementById(obj.id + "_url")!);
            let userTable = (<HTMLInputElement>self.peakidxShadowRoot.getElementById(obj.id + "_usertable")!).value;
            let imageSizes = "";
            if (self.peakidxShadowRoot.getElementById(obj.id + "_imagesizes") != null) {
                imageSizes = (<HTMLInputElement>self.peakidxShadowRoot.getElementById(obj.id + "_imagesizes")!).value;
            }
            // console.log("change file", self.id, userTableElement);
            let isUserTable = false;
            if (userTable == "1") {
                isUserTable = true;
            }
            let uploadProgress = new ZIDXFileUploadProgress(<HTMLFormElement>self.peakidxShadowRoot.getElementById(formId), previewElement, fieldElement, this, isImage, isUserTable, imageSizes, urlElement, progressElement, self);
            uploadProgress.doUpload();
        });

    }
    loadCloudFileFields () {
        let self=this;
        let form = $(".zidxForm", this.peakidxShadowRoot);
        if (form.length > 0) {
            let formId = form[0].id;
            $(".zidxCloudFileField", this.peakidxShadowRoot).each(function (this) {
                if($(this).attr("data-file-change-bound")) {
                    return;
                }
                $(this).attr("data-file-change-bound", "1");
                // console.log("bind file change event", this.id);
                self.setupFileChangeEvent(formId, this, false);
            });
            $(".zidxCloudImageField", this.peakidxShadowRoot).each(function (this) {
                if($(this).attr("data-file-change-bound")) {
                    return;
                }
                $(this).attr("data-file-change-bound", "1");
                // console.log("bind image file change event", this.id);
                self.setupFileChangeEvent(formId, this, true);
            });
        }
    };
    initAccordions() {
        let self=this;
        $(".zidxFormAccordionHeader", this.peakidxShadowRoot).on("click", function (this: HTMLElement, e: JQuery.ClickEvent) {
            e.preventDefault();
            let contentClass=$(this).attr("data-content")!;
            $(contentClass, self.peakidxShadowRoot).toggle();
        });
    }
    loadRecaptcha() {
        if (this.recaptchaLoaded) return; // make sure we only load the javascript library once.
        if (this.options.debug) console.log("loadRecaptcha");
        const script = document.createElement("script");
        script.src = "https://www.google.com/recaptcha/api.js?render=" + this.options.recaptchaSiteKey;
        if(this.peakidxShadowRoot instanceof ShadowRoot) {
            ($(this.peakidxShadowRoot)[0] as ShadowRoot).appendChild(script);
        }else{
            ($(this.peakidxShadowRoot)[0] as Document).documentElement.appendChild(script);
        }
        this.recaptchaLoaded = true;
    }
    loadTinyMCE(callback: Function) {
        if (this.tinyMCELoaded) {
            callback();
            return; // make sure we only load the javascript library once.
        }
        // if (this.options.debug) console.log("loadTinyMCE");

        return $.getScript("/static/js/tiny_mce/tinymce.min.js", (t: any, u: any) => {
            this.tinyMCELoaded = true
            callback()
        });
    }
    getVersionURL(link: string, useForeverCache: boolean) {
        if (link.substr(0, 2) == "//") {
            return link;
        }
        if (link.substr(0, 1) != "/") {
            throw("link, \"" + link + "\", must start with a slash for versioning to work.");
        }
        if (link.substr(0, 4) == "/zv.") {
            throw("link, \"" + link + "\", is already versioned.");
        }
        var prefix = "";
        return prefix + "/zv" + this.options.versionDate + link;
    }

    // function to load tinymce lib if there are any if there is at least one tinymce form field
    initTinyMCEEditors() {
        let elements: JQuery = $("textarea.zidxTinyMCEEditor", this.peakidxShadowRoot);
        if (!elements.length) return;
        // console.log("trying to load tinymce editors");
        this.loadTinyMCE(() => {
            tinymce.remove("textarea.zidxTinyMCEEditor");
            // prevent reusing editors
            tinymce.EditorManager.editors = [];
            // we need that otherwise not found errors
            tinymce.baseURL = '/static/js/tiny_mce'
            tinymce.suffix = '.min'
            // no need to generate unique id for tiny mce editors since we target element directly
            elements.each((index, element) => {
                // console.log("load tinymce editor:" + index);
                let options = {
                    target: element,
                    branding: false,
                    menubar: false,
                    plugins: [
                        ' advlist autolink lists link image charmap print preview anchor textcolor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table contextmenu paste code'
                    ],
                    content: '',
                    toolbar: 'undo redo |  formatselect | bold italic | alignleft aligncenter alignright alignjustify | link bullist numlist outdent indent | removeformat',
                    content_css: [],
                    setup: function (ed: any) {
                        ed.on('blur', function (e: any) {
                            if (typeof window.tinyMCE != "undefined") {
                                window.tinyMCE.triggerSave();
                            }
                        });
                    },
                    width: element.getAttribute("width"),
                    height: element.getAttribute("height"),
                    fix_table_elements: 0,
                    document_base_url: '/',
                    convert_urls: 0,
                    browser_spellcheck: true,
                    gecko_spellcheck: true,
                    paste_remove_spans: 1,
                    remove_script_host: 0,
                    relative_urls: 0,
                    forced_root_block: 'p',
                }
                tinymce.init(options)
                    .then((editors: any) => {
                        editors.forEach((e: any) => {
                            e.setContent(element.textContent)
                        })
                    })
            })
        })
    }
}
